import { brandfolderColorPalette } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Pagination } from '../common/Pagination';
import { PeopleTagsDropdown } from '../common/PeopleTagsDropdown';
import { PersonDetailsParamKeys } from '../customPeopleTagTypes';
import { usePersonDetailsQueryState } from '../hooks/usePersonDetailsQueryState';

import { PersonDetailsHeader } from './PersonDetailsHeader';

const PersonDetailsPageWrapper = styled.div`
  margin: 40px auto;
  max-width: 1608px;
  width: 93%;
`;

const ActionBarWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  padding-bottom: 36px;

  .heading {
    color: ${brandfolderColorPalette.neutrals[500]};
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
  }

  .dropdown-button,
  ul#sort-dropdown-list {
    width: 244px;
  }
`;

export const PersonDetailsPage: FunctionComponent = () => {
  const [state, setState] = usePersonDetailsQueryState();

  const setSortByState = (key: string): void => {
    setState({ [PersonDetailsParamKeys.Sort]: key });
  };
  const perPage = 10;
  const total = 20;

  return (
    <PersonDetailsPageWrapper>
      <PersonDetailsHeader />
      <ActionBarWrapper>
        <span className='heading'>
          <Trans>MATCHING PHOTOS</Trans>
        </span>
        <PeopleTagsDropdown
          selectedValue={state.sort}
          setSelectedValue={setSortByState}
          type='sort' />
      </ActionBarWrapper>
      <Pagination
        page={Number(state.page) || 1}
        perPage={perPage}
        setPage={setState}
        total={total}
      />
    </PersonDetailsPageWrapper>
  );
};
